// extracted by mini-css-extract-plugin
export default {"page":"RfxZWq67YIYQ5451Rn_5","header":"IAfZJITIHAtR2WZ3rXcQ"};